<template>
  <megabit-base-dialog :show-dialog="true" :width="1024">
    <template v-slot:body>
      <v-card color="rgba(0, 0, 0, 0.92)">
        <v-card-title class="align-self-center">
          <span class="text-h6 white--text"
            >{{
              $t('title-forms.cadastro', { nome: $t('menu-home.grupo') })
            }}
            (alt+r)</span
          >
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="formValid">
            <v-row dense class="d-block">
              <v-col md="3" xs="3" sm="4" class="d-sm-inline-block">
                <c-input
                  :label="$t('labels.codigo')"
                  :placeholder="$t('labels.codigo')"
                  :maxLength="4"
                  :isRequired="true"
                  v-model="form.CODIGO"
                />
              </v-col>
              <v-col md="4" xs="3" sm="4" class="d-sm-inline-block">
                <c-input
                  :label="$t('labels.abreviatura')"
                  :placeholder="$t('labels.abreviatura')"
                  :maxLength="15"
                  v-model="form.ABREVIATURA"
                />
              </v-col>
              <v-col md="4" xs="3" sm="4" class="d-sm-inline-block">
                <c-select
                  :rotulo="`${$t('labels.venda')} Internet`"
                  itemText="text"
                  itemValue="value"
                  :lista="translatedOptions"
                  :item.sync="selectedOption.option"
                  v-model="form.VENDAINTERNET"
                />
              </v-col>
            </v-row>
            <v-row dense class="d-block">
              <v-col md="4" xs="3" sm="4" class="d-sm-inline-block">
                <c-input
                  :label="$t('labels.descricao')"
                  :placeholder="
                    `${$t('placeholders.digite', {
                      campo: $t('labels.descricao'),
                    })} grupo`
                  "
                  :maxLength="40"
                  :minLength="3"
                  :isRequired="true"
                  v-model="form.DESCRICAO"
                />
              </v-col>
              <v-col md="4" xs="3" sm="4" class="d-sm-inline-block">
                <c-input
                  :label="`${$t('labels.descricao')} 'G'`"
                  :placeholder="
                    `${$t('placeholders.digite', {
                      campo: $t('labels.descricao'),
                    })} 'G' grupo`
                  "
                  :maxLength="40"
                  :minLength="0"
                  v-model="form.DESCRICAOG"
                />
              </v-col>
              <v-col md="4" xs="3" sm="4" class="d-sm-inline-block">
                <c-input
                  :label="$t('labels.classificacao')"
                  :placeholder="
                    `${$t('placeholders.digite', {
                      campo: $t('labels.classificacao'),
                    })} grupo`
                  "
                  :maxLength="11"
                  :isRequired="false"
                  v-model="form.CLASSIFICACAO"
                />
              </v-col>
            </v-row>
            <v-row dense class="d-block">
              <v-col md="2" xs="3" sm="4" class="d-sm-inline-block">
                <c-input
                  :label="`${$t('labels.margem')} Varejo`"
                  :placeholder="'M. Varejo'"
                  min="1"
                  step="0.01"
                  :maxLength="5"
                  :type="'number'"
                  :value="form.MARGEMVAREJO"
                  :isRequired="false"
                  @blur="formataValor($event, 'MARGEMVAREJO')"
                  suffix="%"
                />
              </v-col>
              <v-col md="2" xs="3" sm="4" class="d-sm-inline-block">
                <c-input
                  :label="`${$t('labels.margem')} Atacado`"
                  :placeholder="'M. Atacado'"
                  :maxLength="5"
                  :type="'number'"
                  min="1"
                  step="0.01"
                  :value="form.MARGEMATACADO"
                  :isRequired="false"
                  @blur="formataValor($event, 'MARGEMATACADO')"
                  suffix="%"
                />
              </v-col>
              <v-col md="2" xs="3" sm="4" class="d-sm-inline-block">
                <c-input
                  :label="`${$t('labels.margem')} Especial`"
                  :placeholder="'M. Especial'"
                  :maxLength="5"
                  :type="'number'"
                  min="1"
                  step="0.01"
                  :value="form.MARGEMESPECIAL"
                  :isRequired="false"
                  @blur="formataValor($event, 'MARGEMESPECIAL')"
                  suffix="%"
                />
              </v-col>
              <v-col md="3" xs="3" sm="4" class="d-sm-inline-block">
                <c-input
                  :label="`${$t('labels.margem')} Especial 2`"
                  :placeholder="'M. Especial 2'"
                  :maxLength="5"
                  :type="'number'"
                  min="1"
                  step="0.01"
                  :value="form.MARGEMESPECIAL2"
                  :isRequired="false"
                  @blur="formataValor($event, 'MARGEMESPECIAL2')"
                  suffix="%"
                />
              </v-col>
              <v-col md="3" xs="3" sm="4" class="d-sm-inline-block">
                <c-input
                  :label="`${$t('labels.margem')} Especial 3`"
                  :placeholder="'M. Especial 3'"
                  :maxLength="5"
                  :type="'number'"
                  min="1"
                  step="0.01"
                  :value="form.MARGEMESPECIAL3"
                  :isRequired="false"
                  @blur="formataValor($event, 'MARGEMESPECIAL3')"
                  suffix="%"
                />
              </v-col>
            </v-row>
            <v-row dense class="d-block">
              <v-col md="2" xs="3" sm="4" class="d-sm-inline-block">
                <c-input
                  :label="$t('labels.comissao')"
                  :placeholder="$t('labels.comissao')"
                  :maxLength="5"
                  :type="'number'"
                  min="1"
                  step="0.01"
                  :value="form.COMISSAO"
                  :isRequired="false"
                  @blur="formataValor($event, 'COMISSAO')"
                  suffix="%"
                />
              </v-col>
            </v-row>
            <v-row dense class="d-block">
              <v-col md="2" xs="3" sm="4" class="d-sm-inline-block">
                <c-input
                  :label="`${$t('labels.comissao')} ext. Varejo`"
                  :placeholder="'C. ext. Varejo'"
                  :maxLength="5"
                  :type="'number'"
                  min="1"
                  step="0.01"
                  :value="form.COMISEXTVAREJO"
                  :isRequired="false"
                  @blur="formataValor($event, 'COMISEXTVAREJO')"
                  suffix="%"
                />
              </v-col>
              <v-col md="2" xs="3" sm="4" class="d-sm-inline-block">
                <c-input
                  :label="`${$t('labels.comissao')} ext. Atacado`"
                  :placeholder="'C. ext. Atacado'"
                  :maxLength="5"
                  :type="'number'"
                  min="1"
                  step="0.01"
                  :value="form.COMISEXTTACADO"
                  :isRequired="false"
                  @blur="formataValor($event, 'COMISEXTTACADO')"
                  suffix="%"
                />
              </v-col>
              <v-col md="2" xs="3" sm="4" class="d-sm-inline-block">
                <c-input
                  :label="`${$t('labels.comissao')} ext. Especial`"
                  :placeholder="'C. ext. Especial'"
                  :maxLength="5"
                  :type="'number'"
                  min="1"
                  step="0.01"
                  :value="form.COMISEXTESPECIAL"
                  :isRequired="false"
                  @blur="formataValor($event, 'COMISEXTESPECIAL')"
                  suffix="%"
                />
              </v-col>
              <v-col md="3" xs="3" sm="4" class="d-sm-inline-block">
                <c-input
                  :label="`${$t('labels.comissao')} ext. Especial 2`"
                  :placeholder="'C. ext. Especial 2'"
                  :maxLength="5"
                  :type="'number'"
                  min="1"
                  step="0.01"
                  :value="form.COMISEXTESPECIAL2"
                  :isRequired="false"
                  @blur="formataValor($event, 'COMISEXTESPECIAL2')"
                  suffix="%"
                />
              </v-col>
              <v-col md="3" xs="3" sm="4" class="d-sm-inline-block">
                <c-input
                  :label="`${$t('labels.comissao')} ext. Especial 3`"
                  :placeholder="'C. ext. Especial 3'"
                  :maxLength="5"
                  :type="'number'"
                  min="1"
                  step="0.01"
                  :value="form.COMISEXTESPECIAL3"
                  @blur="formataValor($event, 'COMISEXTESPECIAL3')"
                  suffix="%"
                />
              </v-col>
            </v-row>
            <v-row dense class="d-block">
              <v-col md="6" sm="6" class="d-sm-inline-block">
                <c-select
                  item-text="DESCRICAO"
                  item-value="CODIGO"
                  :lista="contasestoque"
                  :item.sync="form.contaestoque"
                  :rotulo="
                    $t('placeholders.contas-de', { nome: $t('labels.estoque') })
                  "
                  v-model="form.CONTAESTOQUE"
                  :loading="loadings.contaestoque"
                  @searchinput="updateContas($event, 'contaestoque')"
                >
                </c-select>
              </v-col>
              <v-col md="6" sm="6" class="d-sm-inline-block">
                <c-select
                  item-text="DESCRICAO"
                  item-value="CODIGO"
                  :lista="contascmv"
                  :item.sync="form.contacmv"
                  :rotulo="$t('placeholders.contas-de', { nome: 'CMV' })"
                  v-model="form.CONTACMV"
                  :loading="loadings.contacmv"
                  @searchinput="updateContas($event, 'contacmv')"
                >
                </c-select>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <form-buttons @goBack="goBack()" @submitForm="validateForm()" />
      </v-card>
    </template>
  </megabit-base-dialog>
</template>

<script>
import BaseDialog from '@/components/shared/base-dialog/BaseDialog'
import cInput from '@/components/shared/base-input/BaseInput'
import cSelect from '@/components/shared/base-input/BaseSelect.vue'
import FormButtons from '@/components/shared/base-buttons/FormButtons'
import { itemGroupMixin } from '@/mixins/object/item-group/ItemGroupMixin'
import { currencyMixin } from '@/mixins/object/currency/CurrencyMixin'
import { mapActions, mapGetters } from 'vuex'

export default {
  mixins: [itemGroupMixin, currencyMixin],
  components: {
    'megabit-base-dialog': BaseDialog,
    cInput,
    cSelect,
    FormButtons,
  },
  data: () => ({
    loadings: {
      contaestoque: false,
      contacmv: false,
    },
    isUpdate: false,
    nextCode: 1,
    registerDialog: true,
    formValid: false,
    contasestoque: [],
    contascmv: [],
    // Opções para o select MOSTRASALDONAVENDA
    options: [
      { label: 'sim', value: 'S' },
      { label: 'nao', value: 'N' },
    ],
    selectedOption: {
      // Opção selecionada MOSTRASALDONAVENDA
      option: {},
    },
    id: '',
    form: {
      CODIGO: '',
      DESCRICAO: '',
      CLASSIFICACAO: '',
      ABREVIATURA: '',
      MARGEMVAREJO: '',
      MARGEMATACADO: '',
      MARGEMESPECIAL: '',
      MARGEMESPECIAL2: '',
      MARGEMESPECIAL3: '',
      COMISSAO: '',
      COMISEXTVAREJO: '',
      COMISEXTTACADO: '',
      COMISEXTESPECIAL: '',
      COMISEXTESPECIAL2: '',
      COMISEXTESPECIAL3: '',
      VENDAINTERNET: '',
      contaestoque: '',
      contacmv: '',
    },
  }),
  computed: {
    ...mapGetters({ accountList: 'accountsModule/getComboBoxAccountList' }),
    translatedOptions() {
      return this.options.map((element) => {
        element.text = this.$i18n.t(`labels.${element.label}`)
        return element
      })
    },
    //Ver o breakpoint da página
    // breakpoint() {
    //   return this.$vuetify.breakpoint.name;
    // },
  },
  methods: {
    ...mapActions('itemGroupModule', [
      'getItemGroup',
      'updateItemGroup',
      'insertItemGroup',
      'createItemGroup',
    ]),
    ...mapActions('accountsModule', ['getAccounts']),
    ...mapActions('dialogModule', [
      'setShowLoadingDialog',
      'setLoadingDialogMessage',
    ]),
    async validateForm() {
      if (!this.$refs.form.validate()) {
        this.$toasted.error(this.$t('validation-messages.corrigir'))
        return
      }

      try {
        this.setShowLoadingDialog(true)
        this.setLoadingDialogMessage(this.$t('messages.enviarRegistro'))
        let response
        if (!this.isUpdate) {
          response = await this.insertItemGroup(this.form)
        } else {
          response = await this.updateItemGroup({
            form: this.form,
            id: this.id,
          })
        }
        this.$toasted.success(response)
        this.$router.push({ name: 'Grupo' })
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      } finally {
        this.setShowLoadingDialog(false)
      }
    },
    goBack() {
      this.$router.push({ name: 'Grupo' })
    },
    async setData(id = null) {
      try {
        if (id) {
          let itemGroup = await this.getItemGroup(id)
          this.form = {
            ...itemGroup,
          }
          /* Formata os campos decimais*/
          Object.keys(this.form).forEach((key) => {
            if (
              key == 'COMISSAO' ||
              key == 'COMISSAOEXTVAREJO' ||
              key == 'COMISSAOEXTTACADO' ||
              key == 'COMISSAOEXTESPECIAL' ||
              key == 'COMISSAOEXTESPECIAL2' ||
              key == 'COMISSAOEXTESPECIAL3' ||
              key == 'MARGEMVAREJO' ||
              key == 'MARGEMATACADO' ||
              key == 'MARGEMESPECIAL' ||
              key == 'MARGEMESPECIAL2' ||
              key == 'MARGEMESPECIAL3'
            ) {
              this.form[key] = this.formatDecimal(this.form[key])
            }
          })
          /* Valor inicial para o campo conta estoque*/
          let est = this.form.contaestoque
            ? [
                {
                  CODIGO: this.form.contaestoque.CODIGO,
                  DESCRICAO:
                    this.form.contaestoque.CODIGO +
                    ' - ' +
                    this.form.contaestoque.NOME +
                    ' - ' +
                    this.form.contaestoque.TIPO,
                },
              ]
            : [
                {
                  CODIGO: '',
                  DESCRICAO: this.$t('labels.semDados'),
                  disabled: true,
                },
              ]
          this.contasestoque = est
          /* Valor inicial para o campo conta cmv*/
          let cmv = this.form.contacmv
            ? [
                {
                  CODIGO: this.form.contacmv.CODIGO,
                  DESCRICAO:
                    this.form.contacmv.CODIGO +
                    ' - ' +
                    this.form.contacmv.NOME +
                    ' - ' +
                    this.form.contacmv.TIPO,
                },
              ]
            : [
                {
                  CODIGO: '',
                  DESCRICAO: this.$t('labels.semDados'),
                  disabled: true,
                },
              ]
          this.contascmv = cmv
          // Preenche o select VENDAINTERNET com os dados iniciais do banco
          let o = this.options.filter((e) => {
            if (e.value == this.form.VENDAINTERNET) {
              return e
            }
          })
          this.selectedOption.option = o[0]
          this.isUpdate = !this.isUpdate
        } else {
          let codigo = await this.createItemGroup()
          this.form.CODIGO = codigo
        }
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
    /*  Atualiza a lista do ComboBox do Conta de Estoque e Conta CMV
        por código ou nome da Conta
     */
    async updateContas($event, tipo) {
      try {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          let param = $event && $event.target.value ? $event.target.value : null
          let obj = parseInt(param)
            ? { page: 1, codigo: param }
            : { page: 1, nome: param }
          this.getDados(obj, tipo)
        }, 600)
      } catch (error) {
        this.$toasted.error(`Erro na função updateContas() ${error} `)
      }
    },
    async getDados(payload, tipo) {
      try {
        this.loadings[tipo] = true
        await this.getAccounts(payload)
        if (tipo == 'contaestoque') this.contasestoque = this.accountList
        else this.contascmv = this.accountList
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      } finally {
        this.loadings[tipo] = false
      }
    },
    formataValor($event, field) {
      if ($event && $event.target.value) {
        let value = this.formatDecimal($event.target.value)
        if (value < 0) {
          value = 0
        }
        this.form[field] = value
      }
    },
  },

  mounted: function() {
    this.id = this.$route.params.id
    this.setData(this.id)
  },
}
</script>
